import React from 'react';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import Chip from '@mui/material/Chip';
import { LANGUAGES_OPTIONS, getLabelByValue } from 'utils/languages';
import { useTranslation } from 'react-i18next';

const LanguageFilter = (props) => {
  const { item, applyValue } = props;
  const { t } = useTranslation();

  const handleFilterChange = (newValue) => {
    applyValue({ ...item, value: newValue });
  };

  const handleChange = (languages) => {
    handleFilterChange(languages);
  };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        pt: '2px',
        width: '200px',
      }}>
      <Autocomplete
        multiple
        disableCloseOnSelect
        sx={{ width: '100%' }}
        id="tags-standard"
        options={LANGUAGES_OPTIONS.map((lang) => lang.value)}
        getOptionLabel={(option) => t(getLabelByValue(option))}
        onChange={(event, newValue) => {
          handleChange(newValue);
        }}
        value={item.value ? item.value : []}
        renderTags={(value, getTagProps) => {
          const numTags = value.length;
          const limitTags = 1;
          return (
            <>
              {value.slice(0, limitTags).map((option, index) => (
                <Chip
                  sx={{ height: '20px' }}
                  size="small"
                  {...getTagProps({ index })}
                  key={index}
                  label={t(getLabelByValue(option))}
                />
              ))}
              {numTags > limitTags && <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>...</Typography>}
            </>
          );
        }}
        renderInput={(params) => <TextField {...params} variant="standard" label="Languages" />}
      />
    </Box>
  );
};

const LanguageFilterOperators = [
  {
    label: 'Above',
    value: 'above',
    getApplyFilterFn: (filterItem) => {},
    InputComponent: LanguageFilter,
  },
];

export default LanguageFilterOperators;
